import { gql } from "@stadium/services/apollo-client";
import { PACKAGE_DATA } from "@stadium/hooks/graphql/fragments/package";
import { CONTACT_PROVIDER_DETAILS } from "@stadium/hooks/graphql/fragments/contacts/contact-provider";
import { USER_LOGO_STATUS } from "@stadium/hooks/graphql/fragments/user/logo-status";

export const fetchUser = gql`
  query getUser @api(name: "users") {
    currentUser {
      id: spreeId
      spreeId
      email
      dialCode
      firstName
      lastName
      role
      dateOfBirth
      department
      avatarUrl
      ldUserKey
      fullName
      ldSecureModeHash
      phone
      countryName
      companyName
      programMultipleUsersPostMessage
      workspacesByDomainExists
      walletBalance
      contactFilters
      company {
        id
        name
      }
      corporateBilled
      profile {
        id
        organizerOrderCount
        recipientOrderCount
        autoTopUpPaymentMethod
        contactsShareName
        contactsSharePhoneNo
        contactsShareAddress
        lowFundsNotificationThreshold
        autoTopUpAmount
        autoTopUpMinBalance
        autoTopUpPaymentMethod
        autoTopUpPaymentMethodId
        autoTopUpNotes
        autoTopUpAddFundsSeen
        personalWorkspaceNudgeLastDismissedAt
      }
      accounts {
        id
        name
      }
      walletCurrency {
        id
        name
        code
        symbol
      }
      role
      contactProviders {
        ...ContactProviderDetails
      }
      isActivePackageAdmin
      childCompanies {
        id
        number
        name
        seatsAdded
        adminsCount: totalCurrentUsers
        seatsLeft
        additionalCostPerSeat
        subscription {
          renewalOverdue
        }
        activePackage {
          ...PackageData
        }
      }
      permissions
      isSsoEnabled
    }
    teams {
      id
      name
      currencyCode
      unallocatedWalletBalance
      myWalletBalance
      currentUserRole
      isCurrentUserOwner
    }
  }
  ${PACKAGE_DATA}
  ${CONTACT_PROVIDER_DETAILS}
`;

export const fetchUserDetail = gql`
  query User($kind: String) {
    user {
      ...UserLogoStatus
      hasDigitalAssets(kind: $kind)
    }
  }
  ${USER_LOGO_STATUS}
`;
